import { CanDeactivateFn } from '@angular/router';

export interface PendingBuilderSaveAware {
  flushPendingChanges(): Promise<void>;
}

export const pendingBuilderSaveGuard: CanDeactivateFn<PendingBuilderSaveAware> = async (component) => {
  await component.flushPendingChanges();
  return true;
};
